import DataIsReprocessingBar from 'components/ReusableComponents/DataIsReprocessingBar'
import Table, { TitleCell, TitleRow } from 'components/ReusableComponents/Table'
import { useDebounce } from 'hooks/useDebounce'
import PropTypes from 'prop-types'
import { useState } from 'react'

import SearchTextInput from '../../SearchTextInput/index'
import AddGuestButton from '../AddGuestButton/index'
import styles from './ArrivalList.module.scss'
import ArrivalListTable from './ArrivalListTable'

const ArrivalList = ({
  arrivals,
  handleSetupClick,
  handleAddGuestClick,
  inHouse,
  todaysArrivals
}) => {
  const [tab, setTab] = useState('checkin')
  const [filterKey, setFilterKey] = useState('')
  const debouncedFilterKey = useDebounce(filterKey, 500)

  const [sortIndex, setSortIndex] = useState(4)
  const [sortAscending, setSortAscending] = useState(false)
  const groupBookingsWithSameName = false

  function handleTitleClick(i) {
    const sortableIndexes = [1, 2, 3, 4, 5, 6, 7, 8]

    if (sortIndex === i) {
      setSortAscending(d => !d)
    }

    if (sortableIndexes.includes(i)) {
      setSortIndex(i)
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.filterContainer}>
        <div className={styles.tabs}>
          <button
            className={tab === 'checkin' ? styles.activeTab : styles.emptyTab}
            onClick={() => setTab('checkin')}
          >
            Checked-in guests ({inHouse})
          </button>
          <button
            className={tab === 'today' ? styles.activeTab : styles.emptyTab}
            onClick={() => setTab('today')}
          >
            Today's arrivals ({todaysArrivals})
          </button>
        </div>
      </div>
      <div className={styles.filteredBar}>
        <DataIsReprocessingBar marginTop={0} marginBottom={40} />
        <div className={styles.filterContainer}>
          <AddGuestButton onClick={handleAddGuestClick} />
          <div className={styles.searchContainer}>
            <SearchTextInput
              placeholder="Search with name, room, city or loyalty id..."
              handleChange={setFilterKey}
              activeTab={tab}
              key={tab}
            />
          </div>
        </div>
      </div>
      {arrivals.length ? (
        <>
          <div className={styles.softer}>In-property invites</div>
          <Table
            widths={
              tab === 'checkin'
                ? [40, 180, 170, 60, 80, 80, 130, 100, 100, 120]
                : [40, 180, 170, 60, 80, 80, 130, 200, 200]
            }
            sortIndex={sortIndex}
            sortDirection={sortAscending ? 'up' : 'down'}
            handleTitleCellClick={handleTitleClick}
            className={styles.arrivalsTable}
          >
            <TitleRow>
              <TitleCell></TitleCell>
              <TitleCell>Full name</TitleCell>
              <TitleCell>City,State</TitleCell>
              <TitleCell>Room</TitleCell>
              <TitleCell>Check-in</TitleCell>
              <TitleCell>Check-out</TitleCell>
              <TitleCell>Phone number</TitleCell>
              <TitleCell>1 Day before</TitleCell>
              {tab === 'checkin' && <TitleCell>During Check-in</TitleCell>}
              <TitleCell></TitleCell>
            </TitleRow>
            <ArrivalListTable
              arrivals={arrivals}
              groupBookingsWithSameName={groupBookingsWithSameName}
              sortAscending={sortAscending}
              sortIndex={sortIndex}
              filterKey={debouncedFilterKey}
              tab={tab}
              handleSetupClick={handleSetupClick}
              handleAddGuestClick={handleAddGuestClick}
            />
          </Table>
        </>
      ) : (
        <div className={styles.noResults}>
          <p>No guests found. Walk-in guest?</p>
          <AddGuestButton onClick={handleAddGuestClick} />
        </div>
      )}
    </div>
  )
}

ArrivalList.propTypes = {
  arrivals: PropTypes.array.isRequired,
  handleSetupClick: PropTypes.func.isRequired,
  handleAddGuestClick: PropTypes.func.isRequired
}

export default ArrivalList
